export const messages = {
  "Home": "Akèy",
  "Loading metadata": "Chajman",
  "Application bootstrap failed": "Aplikasyon an pa t kapab demare",
  "Communication failed with the server, please check your internet connection and refresh the page": "Kominikasyon ak sèvè a echwe. Verifye koneksyon Entènèt ou epi rafrechi paj la.",
  "en-US": "Angle",
  "fr-FR": "Franse",
  "ht-HT": "Ayisyen",

  "stats.title": "Estatistik enskripsyon elektoral",
  "stats.subtitle": "Estatistik piblik aktyèl sou elektè enskri ak demann enskripsyon elektoral.",
  "stats.applicantHighlights": "Endikatè kle enskripsyon",
  "stats.registeredVoters": "Elektè enskri",
  "stats.applicants": "Moun ki fè demann",
  "stats.activeOperators": "Operatè aktif",
  "stats.activeCenters": "Sant enskripsyon aktif",
  "stats.configuredCenters": "Sant enskripsyon",
  "stats.capacity": "Kapasite",
  "stats.capacityUse": "Itilizasyon kapasite",
  "stats.capacityUseByDepartment": "Itilizasyon kapasite pa depatman",
  "stats.capacityUseByDepartmentSubtitle": "Moun ki fè demann yo kòm pousantaj kapasite enskripsyon ki konfigire a.",
  "stats.applicantActivity": "Aktivite moun ki fè demann yo",
  "stats.applicantActivitySubtitle": "Demann ki soumèt atravè tan.",
  "stats.demographics": "Demografi elektè enskri yo",
  "stats.demographicsSubtitle": "Repartisyon elektè enskri yo selon sèks ak laj.",
  "stats.sexDistribution": "Repartisyon selon sèks",
  "stats.ageDistribution": "Repartisyon selon laj",
  "stats.byDepartment": "Elektè enskri pa depatman",
  "stats.byDepartmentSubtitle": "Repartisyon elektè enskri yo pa depatman.",
  "stats.noData": "Pa gen estatistik disponib.",
  "stats.loading": "Chajman",
  "stats.male": "Gason",
  "stats.female": "Fi",
  "stats.other": "Lòt",
  "stats.pendingProcessing": "Demann k ap trete",
  "stats.unknown": "Enkoni",
  "stats.under18": "Mwens pase 18 an",
  "stats.18to28": "18 rive 28",
  "stats.29to38": "29 rive 38",
  "stats.39to48": "39 rive 48",
  "stats.49to58": "49 rive 58",
  "stats.59to68": "59 rive 68",
  "stats.69plus": "69+",
  "reporting.registrationsByDepartment": "Elektè enskri pa depatman",
  "reporting.standardActivityDepartments": "Distribisyon elektè enskri pa depatman.",
  "reporting.geoRegistrations": "Distribisyon jewografik enskripsyon yo",
  "reporting.geoDrilldownSubtitle": "Distribisyon ak navigasyon nan jewografi elektoral la.",
  "reporting.capacityUtilization": "Itilizasyon kapasite",
  "reporting.capacityUtilizationByDepartment": "Itilizasyon kapasite pa depatman",
  "reporting.capacityUtilizationByDepartmentSubtitle": "Elektè enskri kòm pousantaj kapasite ki konfigire a.",
  "reporting.registeredVoters": "Elektè enskri",
  "reporting.utilization": "Itilizasyon",
  "reporting.noData": "Pa gen done disponib",
  "reporting.high": "Wo",
  "reporting.low": "Ba",
  "geo.capacity": "Kapasite",
  "common.unnamed": "San non",
  "common.level": "Nivo",
  "common.metric": "Endikatè",
  "common.area": "Zòn"
};
